import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import QRCode from "qrcode.react";
// import moment from 'moment'
import {
  Row,
  Col,
  Dropdown,
  Icon,
  Menu,
  Spin,
  Tooltip,
  Input,
  Modal,
  Popover,
  Popconfirm,
  Button,
  notification,
} from "antd";
// import { ExclamationCircleOutlined } from '@ant-design/icons';
import { app, api, config } from "../app";
import Head from "../components/Head";
import Bg from "../components/Bg";
import XZS from "../components/XZS";
import Footer from "../components/Footer";
import NewsDetail from "../components/NewsDetail";
import "../css/home.css";
import command from "./notice/command";
import style from "../css/home.less";
// import HomeAD from '../components/HomeAD';
import {
  checkInsurance,
  getNoticeList,
  getNoticeClick,
  teamIsRegister,
} from "./insure/insure_api";

const SubMenu = Menu.SubMenu;

function checkBtn(item) {
  const obj = {
    text: "参加并支付",
    disabled: false,
  };
  if (item.pay_status === "1") {
    obj.disabled = true;
    obj.text = "已报名";
  } else if (item.pay_status === "2") {
    obj.disabled = true;
    obj.text = "已退款";
  } else if (item.allly_status === 1) {
    obj.disabled = true;
    obj.text = "已结束报名";
  } else if (parseInt(item.join_number) >= parseInt(item.train_number)) {
    obj.disabled = true;
    obj.text = "名额已满";
  } else if (parseInt(item.train_price) === 0) {
    obj.text = "报名参加";
  }
  return obj;
}

class Home extends Component {
  constructor(props) {
    super(props);
    // console.log(props);
    this.state = {
      isUpdate: false,
      token: "",
      version: "",
      loading: true, //加载
      data_loading: true, //加载
      class_loading: true, //加载
      rescueList: [], //救援资讯
      classList: [], //救援技能分类
      search_type_str: "编号",
      search_type: "searchform_code",
      search_val_flag: false,
      detail_visible: false,
      detail_data: {},
      report_modal: false,
      report_date: null,
      notice_modal: false,
      train_modal: false,
      train_info: {},
      notice_info: {},
      notice_modal_loading: false,
      train_modal_loading: false,
      newsList: [],
      reportList: [],
      messageList: [],
      trainList: [],
    };
    app.removeData("link_teamno");
    app.removeData("link_province");
  }

  async componentDidMount() {
    this._isMounted = true;
    this.getTokeni();
    this.handleLoading();
    this.handleData();
    if (config.mall_isDo) {
      app.post(api.getMallActivity).then(({ flag, data, msg }) => {
        if (flag === 1) {
          if (data.is_activity == 1) {
            this.insureModal2 = Modal.warning({
              title: "通知",
              content: (
                <div>
                  {(data.mall_info || []).map((item, index) => {
                    return (
                      <div
                        key={index}
                        style={{
                          marginTop: "1rem",
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                        onClick={() => this.torealize(item.mall_id)}
                      >
                        <img
                          src={config.imgUrl + item.mall_img}
                          alt=""
                          style={{
                            maxWidth: "200px",
                            maxHeight: "200px",
                            marginRight: "10px",
                            width: "auto",
                            height: "auto",
                          }}
                        />
                        <p
                          style={{
                            fontWeight: "bold",
                            color: "#5e92b4",
                            cursor: "pointer",
                          }}
                        >
                          前往了解
                        </p>
                      </div>
                    );
                  })}
                  <p style={{ color: "red", marginTop: "20px" }}>
                    {data.remark || ""}
                  </p>
                </div>
              ),
              centered: true,
              onOk: () => {
                config.mall_isDo = false;
              },
            });
          }
        } else {
          app.alert(msg, "warn");
        }
      });
    }

    // let a = app.getStoreTokeni();
    // console.log({ a: a, b: this.state.version });
    // if (this.state.version == a) {
    //   console.log("金；来");

    // }
  }

  async isLoadModal() {
    if (app.getToken()) {
      // 新功能弹窗,根据用户身份进行展示， 1 为超级管理员，2 为省级管理员， 3 为队伍管理员
      if (app.getData("rights") == 1 || app.getData("rights") == 3) {
        // console.log(NoticeListInfo)
        const loginInfo = {
          indexno: app.getData("indexno"),
          account: app.getData("account"),
        };
        // const NoticeListInfo = await getNoticeList(loginInfo);
        // // console.log(NoticeListInfo)
        // if (NoticeListInfo != "") {
        //   NoticeListInfo.forEach((item) => {
        //     this.openNotification(item); //弹窗
        //   });
        // }

        // app.setData('NoticeListInfo',NoticeListInfo)
      }

      // checkInsurance().then((status) => {
      //   if (status === false) {
      //     this.insureModal = Modal.warning({
      //       title: "系统提示",
      //       content: (
      //         <div>
      //           <div>系统未能查到您的保险记录信息</div>
      //           <div>
      //             请前往{" "}
      //             <span
      //               onClick={this.handleWarnInsure}
      //               style={{ color: "#1890ff", cursor: "pointer" }}
      //             >
      //               购买或上传
      //             </span>
      //             。
      //           </div>
      //         </div>
      //       ),
      //       centered: true,
      //     });
      //   }
      // });

      teamIsRegister().then((data) => {
        if (data.status === false) {
          this.insureModal = Modal.warning({
            title: "系统提示",
            content: <div>{data.tip}</div>,
            centered: true,
          });
        }
      });
    }
  }

  /**
   * 保险紧告
   * @returns {Promise<void>}
   */
  handleWarnInsure = async () => {
    this.props.history.push("/insure");
  };

  componentWillUnmount() {
    this._isMounted = false;
  }

  torealize = (mall_id) => {
    config.mall_isDo = false;
    this.insureModal2.destroy();
    this.props.history.push(`/mall/detail/${mall_id}`);
  };

  setData = (data) => app.setStateSync(this, data);

  /**
   * 数据加载
   * @returns {Promise<void>}
   */
  getTokeni = async () => {
    await this.setData({ data_loading: true });
    let { flag, data, msg } = await app.post(api.getToken);
    const state = { data_loading: false };
    if (flag === 1) {
      // console.log(data);
      this.setData({
        token: data.token,
        version: data.version,
      });
      // 获取旧版本号
      let a = app.getStoreTokeni();
      // console.log("旧版本号 => " + a + " 新版本号 => " + data.version);
      // 当前网站没有保存到version
      if (a == "" || a == undefined) {
        // console.log('当前网站没有保存到version');
        app.setTokeni(data.version);
        this.isLoadModal();
      } else if (a != data.version) {
        // console.log('当前网站version已更新');
        app.setTokeni(data.version);
        this.reloadPage();
      } else {
        this.isLoadModal();
      }
    } else {
      app.alert(msg, "warn");
    }
    this.setData(state);
  };

  /**
   * 数据加载
   * @returns {Promise<void>}
   */
  handleData = async () => {
    await this.setData({ data_loading: true });
    let { flag, data, msg } = await app.post(api.HomeInfo, {
      indexno: app.getData("indexno"),
      account: app.getData("account"),
    });
    const state = { data_loading: false };
    if (flag === 1) {
      state.newsList = data.news_list || [];
      state.reportList = data.reports_list || [];
      state.messageList = data.message_list || [];
      state.trainList = data.train_list || [];
    } else {
      app.alert(msg, "warn");
    }
    this.setData(state);
  };

  /**
   * 加载数据
   */
  handleLoading() {
    const _this = this;
    app.post(api.HomeClassList).then(({ flag, data, msg }) => {
      _this.setState({ class_loading: false });
      if (flag === 1) {
        _this.setState({ classList: data });
      } else {
        app.alert(msg, "warn");
      }
    });
  }

  handleMenuClick = (e) => {
    const search_type_str = e.item.props.children,
      search_type = e.key;
    this.setState({ search_type, search_type_str });
  };

  /**
   * 关闭生成报备对话框
   */
  handleCloseReportModal = () => {
    this.setData({ report_modal: false, report_date: null });
  };

  /**
   * 打开生成报备对话框
   * @param report_date
   */
  handleOpenReportModal = (report_date) => {
    this.setData({ report_modal: true, report_date });
  };

  /**
   * 关闭通知对话框
   */
  handleCloseNoticeModal = () => {
    this.setData({ notice_modal: false, notice_info: {} });
  };

  /**
   * 打开通知对话框
   * @param notice_modal_id
   */
  handleOpenNoticeModal = async (id) => {
    await this.setData({ notice_modal: true, notice_modal_loading: true });
    const params = {
      id,
      indexno: app.getData("indexno"),
      account: app.getData("account"),
    };
    let { flag, data, msg } = await app.post(api.MessagetDetails, params);
    if (flag === 1) {
      this.handleReadNotice(id);
    } else {
      app.alert(msg, "error");
      data = {};
    }
    await this.setData({ notice_info: data, notice_modal_loading: false });
  };

  /**
   * 关闭培训对话框
   */
  handleCloseTrainModal = () => {
    this.setData({ train_modal: false, train_info: {} });
  };

  /**
   * 打开培训对话框
   * @param id
   */
  handleOpenTrainModal = async (id) => {
    await this.setData({ train_modal: true, train_modal_loading: true });
    const params = {
      id,
      indexno: app.getData("indexno"),
      account: app.getData("account"),
    };
    let { flag, data, msg } = await app.post(api.TraintDetails, params);
    if (flag !== 1) {
      app.alert(msg, "error");
      data = {};
    }
    await this.setData({ train_info: data, train_modal_loading: false });
  };

  /**
   * 搜索跳转
   * @returns {boolean}
   */
  handleSearch = (value) => {
    const search_val = value,
      search_val_flag = this.state.search_val_flag;
    if (!search_val) {
      if (search_val_flag === false) {
        this.setState({ search_val_flag: true });
        const timer = setTimeout(() => {
          this.setState({ search_val_flag: false });
          clearTimeout(timer);
        }, 3000);
      }
      return false;
    }
    // this.props.history.push(`/search-result/${this.state.search_type}/${search_val}`);
    this.props.history.push({
      pathname: `/search-result/${this.state.search_type}/${search_val}`,
      search: "?token=" + this.state.token,
    });
  };

  /**
   * 打开详情
   */
  handleOpenDetail = async (id) => {
    await this.setData({ detail_visible: true, detail_loading: true });
    let state = { detail_loading: false };
    let { flag, data, msg } = await app.post(api.NewNewsDetails, {
      id,
      request: "news",
      indexno: app.getData("indexno"),
      account: app.getData("account"),
    });
    if (flag === 1) {
      data.id = id;
      state.detail_data = data;
    } else {
      app.alert(msg, "error");
    }
    await this.setData(state);
  };

  /**
   * 关闭详情
   */
  handleCancelDetail = () => {
    this.setData({ detail_visible: false });
  };

  /**
   * 培训支付
   **/
  handleTrainPay = async (orders_no) => {
    let flag = await command.trainPay2(orders_no);
    if (flag) {
      this.handleCloseTrainModal();
      await this.handleData();
    }
  };

  /**
   * 阅读通知
   * @param id
   */
  handleReadNotice = async (id) => {
    const params = {
      id,
      is_read: 1,
      indexno: app.getData("indexno"),
      account: app.getData("account"),
    };
    let { flag, msg } = await app.post(api.MessagetRead, params);
    if (flag === 1) {
      app.alert(msg, "success");
    } else {
      app.alert(msg, "error");
    }
  };

  /**
   * 不再显示设置
   * @param id
   * @param type
   * @returns {Promise<void>}
   */
  handleNotShow = async (id, type) => {
    let flag = await command.hideMessageOrTrain(id, type);
    if (flag) {
      await this.handleData();
    }
  };

  reloadi = () => {
    window.location.reload();
  };

  // 系统更新提示
  reloadPage = () => {
    let _this = this;
    Modal.warning({
      width: "480px",
      title: "系统已更新版本，欢迎继续使用！",
      okText: "知道了",
      onOk() {
        _this.reloadi();
        _this.setData({
          isUpdate: false,
        });
      },
      onCancel() {
        _this.reloadi();
      },
    });
  };

  // 右侧弹窗
  openNotification = (NoticeListInfo) => {
    // 弹窗位置
    const placement = "bottomRight";
    // icon 的设置
    const iconType = "warning";
    // key作用为关闭弹窗时使用
    const key = NoticeListInfo.id;
    // goMess 跳转参数
    const goMess = {
      //用于组件判断，如果forHome为true就说明跳转后需要进行特定的组件显示选择，如果为false则不进行组件选择
      forHome: true,
      // 需要展示的组件 number
      routerCom: NoticeListInfo.notice_url,
    };
    //let star = NoticeListInfo.notice_title.indexOf('【')
    //let end = NoticeListInfo.notice_title.indexOf('】')
    let pathname = "";
    if (NoticeListInfo.notice_url == "5") {
      pathname = "/ranks/message";
    } else {
      pathname = NoticeListInfo.notice_url;
    }
    // if(NoticeListInfo.notice_title.substring(star+1,end) == '筹备组申请'){
    //   pathname = '/ranks/TeamApplication'
    // }else{
    //   pathname = '/ranks/message'
    // }

    // 跳转到别的页面的方法
    const goMessageSet = () => {
      //  /ranks/message
      this.props.history.push({ pathname: pathname, state: goMess });

      putNoticeClick();
      //当点击跳转后关闭弹窗
      notification.close(key);
    };

    const putNoticeClick = () => {
      const noticeId = {
        id: NoticeListInfo.id,
      };
      getNoticeClick(noticeId);

      // console.log(1)
    };

    notification[iconType]({
      message: "消息通知",
      description: (
        <div>
          {console.log()}
          <div>{NoticeListInfo.notice_title}</div>
          <div style={{ whiteSpace: "pre-wrap" }}>
            {NoticeListInfo.notice_content}
          </div>
          <div style={{ display: "flex" }}>
            <div onClick={() => putNoticeClick()}>
              <Button type="" onClick={() => notification.close(key)}>
                知道了
              </Button>
            </div>

            <div style={{ marginLeft: 30 }}>
              <Button type="primary" onClick={() => goMessageSet()}>
                立即前往
              </Button>
            </div>
          </div>
        </div>
      ),
      placement,
      key,
      // 弹窗限时关闭，null为不关闭
      duration: null,
    });
  };

  // 渲染层
  render() {
    let {
        detail_visible,
        detail_data,
        detail_loading,
        classList,
        search_type_str,
        class_loading,
        search_val_flag,
        data_loading,
        report_modal,
        report_date,
        notice_modal,
        notice_info,
        notice_modal_loading,
        train_modal,
        train_info,
        train_modal_loading,
        newsList,
        reportList,
        messageList,
        trainList,
      } = this.state,
      isLogin = app.getToken(),
      train_btn_info = checkBtn(train_info),
      train_infos = [];
    if (train_modal) {
      if (train_info.is_class === "1") {
        train_infos.push(
          <Row key="1" className="item">
            <Col span={5}>培训周期：</Col>
            <Col span={18} offset={1}>
              {train_info.train_day}天
            </Col>
          </Row>
        );
        let cla = train_info.class;
        if (cla) {
          train_infos.push(
            <Row key="2" className="item">
              <Col span={5}>班级名称：</Col>
              <Col span={18} offset={1}>
                {cla.class_name}
              </Col>
            </Row>,
            <Row key="3" className="item">
              <Col span={5}>培训时间：</Col>
              <Col span={18} offset={1}>
                {cla.startdate + " ~ " + cla.endate}
              </Col>
            </Row>,
            <Row key="4" className="item">
              <Col span={5}>培训地点：</Col>
              <Col span={18} offset={1}>
                {cla.train_site || "无记录"}
              </Col>
            </Row>,
            <Row key="5" className="item">
              <Col span={5}>培训状态：</Col>
              <Col span={18} offset={1}>
                {cla.train_status === "1"
                  ? "进行中"
                  : cla.train_status === "2"
                  ? "已完成"
                  : "未开始"}
              </Col>
            </Row>
          );
        }
      } else {
        train_infos.push(
          <Row key="1" className="item">
            <Col span={5}>培训时间：</Col>
            <Col span={18} offset={1}>
              {train_info.startdate + " ~ " + train_info.endate}
            </Col>
          </Row>,
          <Row key="2" className="item">
            <Col span={5}>培训地点：</Col>
            <Col span={18} offset={1}>
              {train_info.train_site || "暂无"}
            </Col>
          </Row>,
          <Row key="3" className="item">
            <Col span={5}>培训状态：</Col>
            <Col span={18} offset={1}>
              {train_info.train_status === "1"
                ? "进行中"
                : train_info.train_status === "2"
                ? "已完成"
                : "未开始"}
            </Col>
          </Row>
        );
      }
    }
    // if (!isLogin) {
    //   return (<Redirect to="/login"/>)
    // } else {
    return (
      <div className="index">
        <Bg />
        <Head history={this.props.history} />
        <div className="i_content">
          <div className="c_prompt">
            <p className="p_title">存心救援信息公开平台</p>
            <p className="p_text">CUN XIN CHARITY</p>
          </div>
          <Row className="c_search" type="flex" align="middle" justify="center">
            <div className="s_top_b"></div>
            <Input.Group className="s_zj" compact>
              <Col span={5}>
                <Dropdown
                  overlay={
                    <Menu onClick={this.handleMenuClick}>
                      <Menu.Item key="searchform_code">编号</Menu.Item>
                      <Menu.Divider />
                      <Menu.Item key="searchform_name">姓名</Menu.Item>
                      {/*<Menu.Divider />*/}
                      {/*<Menu.Item key="searchform_area">行政省</Menu.Item>*/}
                      {/*<Menu.Divider />*/}
                      {/*<Menu.Item key="4" disabled>*/}
                      {/*  服务时长*/}
                      {/*</Menu.Item>*/}
                      <Menu.Divider />
                      <Menu.Item key="searchform_mobile">手机号码</Menu.Item>
                      <Menu.Divider />
                      <Menu.Item key="searchform_team">队伍</Menu.Item>
                      {/*<Menu.Divider />*/}
                      {/*<SubMenu*/}
                      {/*  key="sub2"*/}
                      {/*  title={*/}
                      {/*    <span>*/}
                      {/*      救援技能*/}
                      {/*      {class_loading ? <Icon type="loading" /> : ""}*/}
                      {/*    </span>*/}
                      {/*  }*/}
                      {/*>*/}
                      {/*  {classList.map((cla) => {*/}
                      {/*    return (*/}
                      {/*      <Menu.Item key={cla.id}>{cla.names}</Menu.Item>*/}
                      {/*    );*/}
                      {/*  })}*/}
                      {/*</SubMenu>*/}
                    </Menu>
                  }
                  trigger={["click"]}
                >
                  <div className="z_s">
                    <span>{search_type_str}</span>
                    <Icon type="down" />
                  </div>
                </Dropdown>
              </Col>
              <Col span={18} offset={1} style={{ height: "100%" }}>
                <Tooltip
                  placement="bottomLeft"
                  title="请输入搜索内容"
                  trigger=""
                  visible={search_val_flag}
                >
                  <Input.Search
                    placeholder="请输入搜索内容"
                    onSearch={(value) => this.handleSearch(value)}
                    style={{ height: "100%" }}
                    size="large"
                    enterButton
                  />
                </Tooltip>
              </Col>
            </Input.Group>
          </Row>
          <div className="c_qjdh"></div>
          {/* eeee */}
          {/* <div className="c_qjdh" >求救电话: 400 600 9958</div> */}
        </div>
        <div className="i_zx">
          <div className="zx_tm" />
          <div className="zx_content">
            {data_loading ? (
              <div className="zx_content-load">
                <Spin size="large" />
              </div>
            ) : (
              <Row className="zx-items">
                <Col span={8} className="zx-item">
                  <Row
                    type="flex"
                    justify="space-between"
                    align="middle"
                    className="zxi-head"
                  >
                    <Col className="zxih-title">最新新闻</Col>
                    <Link to="/news" className="zxih-link">
                      查看更多新闻资讯 <Icon type="right" />
                    </Link>
                  </Row>
                  <div className="zxi-content zxi-content-height">
                    {newsList.map((news, index) => {
                      if (index < 3) {
                        return (
                          <div
                            key={index}
                            className="zxic-item"
                            onClick={() => this.handleOpenDetail(news.id)}
                          >
                            <div className="zxici-img">
                              <img src={config.imgUrl + news.news_img} />
                            </div>
                            <div className="zxici-info">
                              <div className="zxicii-title">
                                {news.news_title}
                              </div>
                              <div className="zxicii-date">
                                <span>{news.release_time}</span>
                                <div className="zxicii-icon">
                                  <span>
                                    <i
                                      className="iconfont icon-yuedu"
                                      style={{ fontSize: ".6rem" }}
                                    />
                                    <span style={{ padding: "0 .25rem" }}>
                                      {news.hits || 0}
                                    </span>
                                  </span>
                                  {/*<Popover*/}
                                  {/*  placement="right"*/}
                                  {/*  content={*/}
                                  {/*    <QRCode*/}
                                  {/*      value={config.shareDoman + news.id}*/}
                                  {/*    />*/}
                                  {/*  }*/}
                                  {/*  title="手机扫码分享"*/}
                                  {/*  overlayStyle={{ textAlign: "center" }}*/}
                                  {/*>*/}
                                  {/*  <span style={{ marginLeft: ".25rem" }}>*/}
                                  {/*    <i*/}
                                  {/*      className="iconfont icon-fenxiang"*/}
                                  {/*      style={{*/}
                                  {/*        fontSize: ".6rem",*/}
                                  {/*        color: "#5E92B4",*/}
                                  {/*      }}*/}
                                  {/*    />*/}
                                  {/*    <span style={{ padding: "0 .25rem" }}>*/}
                                  {/*      分享*/}
                                  {/*    </span>*/}
                                  {/*  </span>*/}
                                  {/*</Popover>*/}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      } else if (index < 8) {
                        return (
                          <Row
                            type="flex"
                            align="bottom"
                            key={index}
                            onClick={() => this.handleOpenDetail(news.id)}
                            className="zxic-item-line"
                          >
                            <span className="zxiciline-title">
                              {news.news_title}
                            </span>
                            <span className="zxiciline-date">
                              {news.release_time}
                            </span>
                          </Row>
                        );
                      } else {
                        return null;
                      }
                    })}
                  </div>
                </Col>
                <Col span={8} className="zx-item">
                  <Row
                    type="flex"
                    justify="space-between"
                    align="middle"
                    className="zxi-head"
                  >
                    <Col className="zxih-title">每日报表</Col>
                    {/*<Link to="/bigdata/work-report" className="zxih-link">*/}
                    {/*  查看所有报表 <Icon type="right" />*/}
                    {/*</Link>*/}
                  </Row>
                  <div className="zxi-content zxi-content-height">
                    {reportList.map((item, index) => {
                      if (index < 5) {
                        return (
                          <div
                            key={index}
                            className="zxic-item zxic-item-no-b"
                            onClick={() =>
                              this.handleOpenReportModal(item.time)
                            }
                          >
                            <div className="zxici-info">
                              <div className="zxicii-title">{item.title}</div>
                              <div className="zxicii-date">
                                <span>{item.create_time}</span>
                                <div className="zxicii-icon">
                                  <span>
                                    <i
                                      className="iconfont icon-yuedu"
                                      style={{ fontSize: ".6rem" }}
                                    />
                                    <span style={{ padding: "0 .25rem" }}>
                                      {item.hits || 0}
                                    </span>
                                  </span>
                                  {/*<Popover*/}
                                  {/*  placement="right"*/}
                                  {/*  content={*/}
                                  {/*    <QRCode*/}
                                  {/*      value={config.reportDoman + item.time}*/}
                                  {/*    />*/}
                                  {/*  }*/}
                                  {/*  title="手机扫码分享"*/}
                                  {/*  overlayStyle={{ textAlign: "center" }}*/}
                                  {/*>*/}
                                  {/*  <span style={{ marginLeft: ".25rem" }}>*/}
                                  {/*    <i*/}
                                  {/*      className="iconfont icon-fenxiang"*/}
                                  {/*      style={{*/}
                                  {/*        fontSize: ".6rem",*/}
                                  {/*        color: "#5E92B4",*/}
                                  {/*      }}*/}
                                  {/*    />*/}
                                  {/*    <span style={{ padding: "0 .25rem" }}>*/}
                                  {/*      分享*/}
                                  {/*    </span>*/}
                                  {/*  </span>*/}
                                  {/*</Popover>*/}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      } else {
                        return null;
                      }
                    })}
                    { reportList.length < 1 ?(<Row type="flex" align="middle" justify="center" className="zx-no-login">暂无报表信息</Row>):''}
                  </div>
                </Col>
                <Col span={8}>
                  <div className="zx-item">
                    <Row
                      type="flex"
                      justify="space-between"
                      align="middle"
                      className="zxi-head"
                    >
                      <Col className="zxih-title">最新通知</Col>
                      {/*{isLogin ? (*/}
                      {/*  <Link to="/notice/list" className="zxih-link">*/}
                      {/*    查看所有通知 <Icon type="right" />*/}
                      {/*  </Link>*/}
                      {/*) : (*/}
                      {/*  <span className="zxih-no-link">*/}
                      {/*    查看所有通知 <Icon type="right" />*/}
                      {/*  </span>*/}
                      {/*)}*/}
                    </Row>
                    <div className="zxi-content zxi-content-height2">
                      {isLogin ? (
                        messageList.length > 0 ? (
                          messageList.map((item, index) => {
                            if (index < 2) {
                              return (
                                <div
                                  key={index}
                                  className="zxic-item zxic-item-no-b"
                                >
                                  <div className="zxici-info">
                                    <div
                                      onClick={() =>
                                        this.handleOpenNoticeModal(item.id)
                                      }
                                      className="zxicii-title"
                                    >
                                      {item.title}
                                    </div>
                                    <div className="zxicii-date">
                                      <span>{item.cteate_time}</span>
                                      <div className="zxicii-icon">
                                        <span>
                                          {item.is_read === "1" ? (
                                            <Popconfirm
                                              title="确定不再显示吗？"
                                              onConfirm={() =>
                                                this.handleNotShow(
                                                  item.id,
                                                  "message"
                                                )
                                              }
                                            >
                                              <span
                                                style={{
                                                  padding: "0 .25rem",
                                                  margin: "0 .5rem",
                                                }}
                                              >
                                                <i
                                                  className="iconfont icon-laji"
                                                  style={{ fontSize: ".6rem" }}
                                                />
                                              </span>
                                            </Popconfirm>
                                          ) : null}
                                          <i
                                            className="iconfont icon-yuedu"
                                            style={{ fontSize: ".6rem" }}
                                          />
                                          <span style={{ padding: "0 .25rem" }}>
                                            {item.hits || 0}
                                          </span>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            } else {
                              return null;
                            }
                          })
                        ) : (
                          <Row
                            type="flex"
                            align="middle"
                            justify="center"
                            className="zx-no-login"
                          >
                            暂无通知信息
                          </Row>
                        )
                      ) : (
                        <Row
                          type="flex"
                          align="middle"
                          justify="center"
                          className="zx-no-login"
                        >
                          <Link to="/login">登录</Link> 后才能查看到通知信息
                        </Row>
                      )}
                    </div>
                  </div>
                  <div className="zx-item zx-px-item">
                    <Row
                      type="flex"
                      justify="space-between"
                      align="middle"
                      className="zxi-head"
                    >
                      <Col className="zxih-title">最新培训</Col>
                      {/*{isLogin ? (*/}
                      {/*  <span className="zxih-link">*/}
                      {/*    查看所有培训 <Icon type="right" />*/}
                      {/*  </span>*/}
                      {/*) : (*/}
                      {/*  // <Link to="/notice/train-list" className="zxih-link">*/}
                      {/*  //   查看所有培训 <Icon type="right" />*/}
                      {/*  // </Link>*/}
                      {/*  <span className="zxih-no-link">*/}
                      {/*    查看所有培训 <Icon type="right" />*/}
                      {/*  </span>*/}
                      {/*)}*/}
                    </Row>
                    <div className="zxi-content zxi-content-height2">
                      {isLogin ? (
                        trainList.length > 0 ? (
                          trainList.map((item, index) => {
                            if (index < 2) {
                              return (
                                <div
                                  key={index}
                                  className="zxic-item zxic-item-no-b"
                                >
                                  <div className="zxici-info">
                                    <div
                                      onClick={() =>
                                        this.handleOpenTrainModal(item.id)
                                      }
                                      className="zxicii-title"
                                    >
                                      {item.trainame}
                                    </div>
                                    <div className="zxicii-date">
                                      <span>{item.create_time}</span>
                                      <div className="zxicii-icon">
                                        <span>
                                          {item.pay_status !== "1" ? (
                                            <Popconfirm
                                              title="确定不再显示吗？"
                                              onConfirm={() =>
                                                this.handleNotShow(
                                                  item.id,
                                                  "train"
                                                )
                                              }
                                            >
                                              <span
                                                style={{
                                                  padding: "0 .25rem",
                                                  margin: "0 .5rem",
                                                }}
                                              >
                                                <i
                                                  className="iconfont icon-laji"
                                                  style={{ fontSize: ".6rem" }}
                                                />
                                              </span>
                                            </Popconfirm>
                                          ) : null}
                                          <i
                                            className="iconfont icon-yuedu"
                                            style={{ fontSize: ".6rem" }}
                                          />
                                          <span style={{ padding: "0 .25rem" }}>
                                            {item.hits || 0}
                                          </span>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            } else {
                              return null;
                            }
                          })
                        ) : (
                          <Row
                            type="flex"
                            align="middle"
                            justify="center"
                            className="zx-no-login"
                          >
                            暂无培训信息
                          </Row>
                        )
                      ) : (
                        <Row
                          type="flex"
                          align="middle"
                          justify="center"
                          className="zx-no-login"
                        >
                          <Link to="/login">登录</Link> 后才能查看到培训信息
                        </Row>
                      )}
                    </div>
                  </div>
                </Col>
              </Row>
            )}
          </div>
          <Footer />
        </div>
        <XZS history={this.props.history} version manual />
        <Modal
          visible={detail_visible}
          footer={null}
          title="新闻详情"
          maskClosable={false}
          width="100%"
          style={{ top: 0, height: "100vh" }}
          bodyStyle={{ height: "calc(100vh - 55px)", overflow: "auto" }}
          onCancel={this.handleCancelDetail}
          zIndex={9999}
          className="news-detail-modal-class"
        >
          <NewsDetail data={detail_data} loading={detail_loading} />
        </Modal>
        <Modal
          visible={report_modal}
          title="生成报表"
          onCancel={this.handleCloseReportModal}
          footer={null}
          width={400}
          centered={true}
          maskClosable={true}
          destroyOnClose={true}
          bodyStyle={{ textAlign: "center", padding: 0, paddingBottom: 10 }}
        >
          <div
            style={{
              textAlign: "right",
              padding: 10,
              borderBottom: "1px solid #ddd",
            }}
          >
            <Popover
              placement="right"
              content={<QRCode value={config.reportDoman + report_date} />}
              title="手机扫码分享"
              overlayStyle={{ textAlign: "center", zIndex: 9999 }}
            >
              <Button type="primary">手机扫码分享</Button>
            </Popover>
          </div>
          <iframe
            src={config.reportDoman + report_date}
            frameBorder="0"
            width="360px"
            height="500px"
          />
        </Modal>
        <Modal
          visible={notice_modal}
          onCancel={this.handleCloseNoticeModal}
          title={<div style={{ textAlign: "center" }}>通知详情</div>}
          footer={null}
          width="80%"
          centered={true}
          maskClosable={true}
          destroyOnClose={true}
        >
          {notice_modal_loading ? (
            <div style={{ textAlign: "center" }}>
              <Spin />
            </div>
          ) : (
            <div className="items">
              <Row className="item">
                <Col span={4}>标题: </Col>
                <Col span={20}>{notice_info.title}</Col>
              </Row>
              <Row className="item">
                <Col span={4}>发布人: </Col>
                <Col span={20}>{notice_info.vname}</Col>
              </Row>
              <Row className="item">
                <Col span={4}>通知级别: </Col>
                <Col span={20}>{notice_info.object}</Col>
              </Row>
              <Row className="item">
                <Col span={4}>发布时间: </Col>
                <Col span={20}>{notice_info.cteate_time}</Col>
              </Row>
              <Row className="item">
                <Col span={4}>通知内容: </Col>
                <Col span={20}>
                  <div
                    className="braft-output-content"
                    dangerouslySetInnerHTML={{ __html: notice_info.content }}
                  />
                </Col>
              </Row>
              {notice_info.images && notice_info.images.length ? (
                <Row className="item">
                  <Col span={20} offset={4}>
                    {notice_info.images.map((img, index) => {
                      return (
                        <a key={index} href={img} target="_blank">
                          <img
                            style={{
                              maxWidth: "100%",
                              width: "auto",
                              heigth: "auto",
                            }}
                            src={config.imgUrl + img}
                            alt=""
                            key={index}
                          />
                        </a>
                      );
                    })}
                  </Col>
                </Row>
              ) : null}
            </div>
          )}
        </Modal>
        <Modal
          visible={train_modal}
          onCancel={this.handleCloseTrainModal}
          width="60%"
          title={<div style={{ textAlign: "center" }}>培训详情</div>}
          centered={true}
          maskClosable={true}
          destroyOnClose={true}
          footer={
            <div style={{ textAlign: "center" }}>
              <Button
                type="primary"
                style={{ marginRight: 20 }}
                disabled={train_modal_loading || train_btn_info.disabled}
                onClick={() => this.handleTrainPay(train_info.orders_no)}
              >
                {train_btn_info.text}
              </Button>
              <Button onClick={() => this.handleCloseTrainModal()}>取消</Button>
            </div>
          }
          bodyStyle={{ height: "calc(90vh - 110px)", overflow: "auto" }}
        >
          {train_modal_loading ? (
            <div style={{ textAlign: "center" }}>
              <Spin />
            </div>
          ) : (
            <div className="items">
              <div
                className="braft-output-content"
                dangerouslySetInnerHTML={{ __html: train_info.train_content }}
                style={{ padding: "20px 0" }}
              />
              <Row className="item">
                <Col span={5}>培训课程：</Col>
                <Col span={18} offset={1}>
                  {train_info.trainame}
                </Col>
              </Row>
              <Row className="item">
                <Col span={5}>培训师：</Col>
                <Col span={18} offset={1}>
                  {train_info.train_teacher}
                </Col>
              </Row>
              {train_infos}
              <Row className="item">
                <Col span={5}>报名截止时间：</Col>
                <Col span={18} offset={1}>
                  {train_info.apply_time}
                </Col>
              </Row>
              <Row className="item">
                <Col span={5}>培训价格：</Col>
                <Col span={18} offset={1}>
                  {parseFloat(train_info.train_price).toFixed(2)} 元
                </Col>
              </Row>
              <Row className="item">
                <Col span={5}>培训人数：</Col>
                <Col span={18} offset={1}>
                  {train_info.train_number}
                </Col>
              </Row>
              <Row className="item">
                <Col span={5}>已报名人数：</Col>
                <Col span={18} offset={1}>
                  {train_info.join_number}
                </Col>
              </Row>
              <Row className="item">
                <Col span={5}>培训级别：</Col>
                <Col span={18} offset={1}>
                  {train_info.object === "1"
                    ? "全国"
                    : train_info.object === "2"
                    ? "省级"
                    : train_info.object === "3"
                    ? "市级"
                    : "队伍"}
                </Col>
              </Row>
              <Row className="item">
                <Col span={5}>培训装备：</Col>
                <Col span={18} offset={1}>
                  {train_info.train_equip || "无"}
                </Col>
              </Row>
              <Row className="item">
                <Col span={5}>培训技能：</Col>
                <Col span={18} offset={1}>
                  {train_info.train_ppe || "无"}
                </Col>
              </Row>
              <Row className="item">
                <Col span={5}>培训时长：</Col>
                <Col span={18} offset={1}>
                  {train_info.train_hour
                    ? train_info.train_hour + "时"
                    : "暂无"}
                </Col>
              </Row>
              <Row className="item">
                <Col span={5}>培训评语：</Col>
                <Col span={18} offset={1}>
                  {train_info.train_comment || "暂无"}
                </Col>
              </Row>
              <Row className="item">
                <Col span={5}>是否支付：</Col>
                <Col span={18} offset={1}>
                  {train_info.pay_status === "1"
                    ? "已支付"
                    : train_info.pay_status === "2"
                    ? "已退款"
                    : "未支付"}
                </Col>
              </Row>
              <Row className="item">
                <Col span={5}>备注：</Col>
                <Col span={18} offset={1}>
                  {train_info.detail || "无"}
                </Col>
              </Row>
              <Row className="item">
                <Col style={{ textAlign: "center" }}>
                  {(train_info.details_images || []).map((img, index) => {
                    return (
                      <div key={index} style={{ marginTop: "1rem" }}>
                        <img
                          src={config.imgUrl + img}
                          alt=""
                          style={{
                            maxWidth: "100%",
                            width: "auto",
                            height: "auto",
                          }}
                        />
                      </div>
                    );
                  })}
                </Col>
              </Row>
            </div>
          )}
        </Modal>
        {/*<HomeAD/>*/}
      </div>
    );
    //}
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/routes/Home.jsx